import type { DiyRecipe } from '../types';
import { PrimaryProtein } from '../types';
import genericDiyRecipeImageWebp from '../assets/generic-diy-recipe-image.webp';

export const eggsRiceAndVegetables: DiyRecipe = {
  id: 'eggs-rice-&-veggies',
  name: 'Eggs, Rice & Veggies',
  primaryProtein: PrimaryProtein.EggsAndVeggies,
  ingredients: [
    {
      name: 'whole egg, raw',
      quantity: 732,
      unit: 'g',
      alternativeQuantity: 12,
      alternativeUnit: 'large',
    },
    {
      name: 'egg white, raw amount',
      quantity: 243,
      unit: 'g',
      alternativeQuantity: 1,
      alternativeUnit: 'cup',
    },
    {
      name: 'long-grain brown rice, uncooked',
      quantity: 266,
      unit: 'g',
      alternativeQuantity: 1.5,
      alternativeUnit: 'cup',
    },
    {
      name: 'peas, frozen, cooked, drained without salt',
      quantity: 142,
      unit: 'g',
      alternativeQuantity: 5,
      alternativeUnit: 'oz',
    },
    {
      name: 'carrots, raw, chopped or diced',
      quantity: 128,
      unit: 'g',
      alternativeQuantity: 1,
      alternativeUnit: 'cup',
    },
    {
      name: 'spinach, raw',
      quantity: 57,
      unit: 'g',
      alternativeQuantity: 0.25,
      alternativeUnit: 'cup',
    },
    {
      name: 'coconut oil',
      quantity: 27,
      unit: 'g',
      alternativeQuantity: 2,
      alternativeUnit: 'tablespoon',
    },
    {
      name: 'salmon oil',
      quantity: 7,
      unit: 'g',
      alternativeQuantity: 0.5,
      alternativeUnit: 'tablespoon',
    },
    {
      name: 'The Farmer’s Dog DIY Nutrient Mix',
      quantity: 1,
      unit: 'packet',
    },
  ],
  ingredientSummary:
    'Egg, Egg white, Brown Rice, Peas, Carrots, Spinach, Coconut Oil, Salmon Oil',
  ingredientsNote:
    'Fresh or frozen vegetables may be used in these recipes. For best results, weigh by grams and use food safe thermometer.',
  cookTime: '35 mins',
  calories: 2430,
  utensils: [
    '5+ quart pot/skillet/dutch oven',
    'knife and cutting board or food processor (or buy pre-cut frozen)',
    'spatula',
    'kitchen scale',
    'food safe thermometer',
  ],
  image: genericDiyRecipeImageWebp,
  instructions: [
    {
      name: 'Step 1',
      description:
        'Cook the raw, brown rice according to the instructions on the packaging and set aside.',
      note: 'While the brown rice may be made the same day as the entire recipe, preparing the rice the day before making the entire recipe will help reduce clumping of the rice in the pan as it is added to the recipe.',
    },
    {
      name: 'Step 2',
      description:
        'Place pot/skillet/dutch oven over medium to medium-high heat on the stovetop. Mix the whole eggs together with the liquid egg whites in a medium-sized bowl and add to the pan. Cook the eggs until they are firm and use a food-safe thermometer to ensure the mixture reaches at least 165°F. Transfer the cooked eggs to a separate bowl and set aside.',
      note: 'In order to maintain safe, ready-to-eat meals it is important that all food reaches the USDA guidelines for safety.',
    },
    {
      name: 'Step 3',
      description:
        'Return the pan to the heat source and add the coconut oil and chopped carrots. Sauté until the carrots are soft (approximately 3–4 minutes).',
    },
    {
      name: 'Step 4',
      description:
        'Add the cooked brown rice, cooked egg, and peas to the pan with the carrots and mix thoroughly, stirring frequently until the peas are warmed. Add the spinach to the pan and stir until the spinach is wilted (approximately 2 minutes).',
      note: 'We recommend using raw, fresh spinach, rather than frozen spinach, in the recipe as it helps prevent clumping. You may need to add a small amount of water (1–2 tablespoons) to help the spinach wilt.',
    },
    {
      name: 'Step 5',
      description:
        'Remove the pot from the heat. Add the salmon oil and sprinkle the 1 packet of The Farmer’s Dog DIY Nutrient Mix evenly across the surface. Stir to evenly distribute throughout the food until you can no longer see the nutrient mix.',
    },
  ],
};
